import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { retry, catchError } from 'rxjs/operators';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { SettingService } from './setting.service';


export interface movements {
  Tipoabt?: string,
  operadorABT?: string,
  codigotipotrx?: number,
  nombreTRX?: string,
  fecha_trx?: string,
  fecha_ajuste?: string,
  codproducto?: number,
  nombreproducto?: string,
  operador?: string,
  estacion?: string,
  servicio?: string,
  MONTO_ABONO?: number,
  MONTO_DESCUENTO?: number

}
export interface consultaAbtResp {
  estado?: any;
  mensaje?: string;
  saldo: String,
  estadoCuenta?: string
  estadoVigencia: string,
  listaTransacciones?: []
}

@Injectable({
  providedIn: 'root'
})
export class TarjetasService {
  constructor(private http: HttpClient, private settingsService: SettingService) { }

  usuario = this.settingsService.settings.usuario;
  pocaeBackend = this.settingsService.settings.pocaeBackend;
  pocaeHitorial = this.settingsService.settings.pocaeHistorial;
  soap = this.settingsService.settings.Soap;
  solicitud = this.settingsService.settings.solicitud;
  abt = this.settingsService.settings.abt;

  error: any;
  card = { cards: [] }
  numCard = ''

  httpOptions = {
    headers: new HttpHeaders({
      "Content-Type": "application/json",
    })
  }

  private tarjeta = new BehaviorSubject(this.card);
  currentTarjeta = this.tarjeta.asObservable();

  private sCard = new BehaviorSubject(this.numCard);
  selectedCard = this.sCard.asObservable();

  addCards(cards) {
    this.card = { cards: cards };
    this.tarjeta.next(this.card)
  }

  selectCard(numCard) {
    this.numCard = numCard;
    this.sCard.next(this.numCard)
  }

  getCards(json) {
    return this.http.post(this.usuario + '/usuario/tarjeta/resumenCol/', JSON.stringify(json), this.httpOptions)
      .pipe(retry(4), catchError(this.error))
  }

  newCard(json) {
    return this.http.post(this.usuario + "/usuario/tarjeta/nuevaSinValidar", JSON.stringify(json), this.httpOptions)
      .pipe(retry(4), catchError(this.error))
  }

  deleteCard(json) {
    return this.http.post(this.usuario + "/usuario/tarjeta/desafiliar", JSON.stringify(json), this.httpOptions)
      .pipe(retry(4), catchError(this.error))
  }

  getMovimientos(numTarjeta, filter) {
    return this.http.post(this.usuario + '/usuario/movimientos?numTarjetaExterno=' + numTarjeta + '&cantDias=' + filter, this.httpOptions)
      .pipe(retry(4), catchError(this.error))
  }

  getRadisponible(numTarjeta) {
    return this.http.post(this.usuario + '/usuario/resumenra?numTarjetaExterno=' + numTarjeta, this.httpOptions)
      .pipe(retry(4), catchError(this.error))
  }

  getSolicitudes(body) {
    return this.http.post(this.solicitud + '/PocaeSolicitud/obtenerListaSolicitud', body, this.httpOptions)
      .pipe(retry(4), catchError(this.error))
  }

  cargarDinero(json) {
    return this.http.post(this.soap + '/SOAPtoREST/visanet/venta', JSON.stringify(json), this.httpOptions)
      .pipe(retry(4), catchError(this.error));
  }

  tagCard(json) {
    return this.http.post(this.usuario + '/usuario/tarjeta/actualizar', JSON.stringify(json), this.httpOptions)
      .pipe(retry(4), catchError(this.error))
  }

  favCard(json) {
    return this.http.post(this.usuario + '/usuario/tarjeta/favorita', JSON.stringify(json), this.httpOptions)
      .pipe(retry(4), catchError(this.error))
  }

  sendData(json) {
    return this.http.post(this.solicitud + "/PocaeSolicitud/enviaSolicitudABT", JSON.stringify(json), this.httpOptions)
  }

  getDetalle(json) {
    return this.http.post(this.usuario + "/usuario/detalleSolicitud", JSON.stringify(json), this.httpOptions)
      .pipe(retry(4), catchError(this.error))
  }

  verificaSolicitudEnCurso(json) {
    return this.http.post(this.solicitud + "/PocaeSolicitud/verificaCantSolicitud", JSON.stringify(json), this.httpOptions)
      .pipe(retry(4), catchError(this.error))
  }

  cargaParametrosSol() {
    return this.http.get(this.solicitud + "/PocaeSolicitud/cargaParametrosSol", this.httpOptions)
      .pipe(retry(4), catchError(this.error))
  }


  //abt

  getTransaccionesAbt(body) {
    return this.http.post<consultaAbtResp>(`${this.abt}/recaudowsrest/producto/consultaTrx`, body);
  }

  getDetail(body) {
    return this.http.post(`${this.abt}/recaudowsrest/producto/consultaCuentas`, body)
  }

  bloqCardPocae(body) {
    return this.http.post<{ numError: number }>(this.solicitud + '/PocaeSolicitud/enviaSolicitudBloqueo', body)
  }
  bloqCard(body) {
    return this.http.post<{ estado: string, mensaje: string }>(this.abt + '/recaudowsrest/producto/bloquearDesbloquear', body)
  }

  validacionMA(nTarjeta): Observable<string> {

    const headers = new HttpHeaders()
      .set('SUBJECT_CONTENT', 'CN=OP.156, OU=transporte, O=sonda, L=santiago, ST=santiago, C=CL ; CN=AP.7, OU=transporte, O=sonda, L=santiago, ST=santiago, C=CL')
    const requestOptions: Object = {
      headers,
      responseType: 'text'
    }
    let body = {
      "codigoOperador": 156,
      "codigoApp": 7,
      "tipoMedioAcceso": "TAG",
      "tipoValidacion": 2,
      "idMedioAcceso": nTarjeta
    }
    return this.http.post<string>(this.abt + '/pagomovil/rest/servicios/validacionMA', body, requestOptions)
  }

}